export default function getResource(label) {
    const resources = {
        // Variant 1: Trial eligible, NOT in basket
        variant1Message: 'Commencez à économiser avec un essai GRATUIT de 30 jours pour la livraison le jour même illimitée Sephora',
        variant1Cta: 'Essayez-la gratuitement',

        // Variant 2: NOT trial eligible, NOT in basket
        variant2Message: 'Commencez à économiser avec la livraison le jour même illimitée de Sephora',
        variant2Cta: 'S’inscrire',

        // Variant 3: Trial eligible, IN basket
        variant3Message: 'Votre panier contient un essai GRATUIT de 30 jours pour la livraison le jour même illimitée',
        variant3Cta: 'En savoir plus',

        // Variant 4: NOT trial eligible, IN basket
        variant4Message: 'Votre panier contient un abonnement à la livraison le jour même illimitée.',
        variant4Cta: 'En savoir plus'
    };

    return resources[label];
}
